import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  isSessionVaild = true
  constructor(private http: HttpClient, public router: Router, private globals: GlobalService) { this.isSessionVaild = true; }

  // Check bed availability from check in date on duration with get class, rate and count of Bed
  getDailyBedCount(startDate: string, duration: number) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetDailyBedCount?startDate=' + startDate + '&duration=' + duration, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
  // Get selected check in date total count of admission
  GetBookingCount(checkinDate) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetBookingCount?checkinDate=' + checkinDate, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
  //Getting Payment History by OnlinePatientRegistrationID
  GetPaymentHistory(OnlinePatientRegistrationID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetPaymentHistory?OnlinePatientRegistrationID=' + OnlinePatientRegistrationID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  // Get All regulation from mstregulation
  GetAllRegulations() {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/GetAllRegulations', { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
  // This function is used to get all Doctor holiday 
  getDoctorHoliday(ClientID, LocationID, CurrentDate, DoctorID) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'Booking/getDoctorHoliday?clientID=' + ClientID
      + '&locationID=' + LocationID + '&currentDate=' + CurrentDate + '&doctorID=' + DoctorID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
}
